import { EAccountType } from '../../../../repositories/offer-card/entities/agent/AgentSchema';
import { CommercialOwnerShield } from '../../../../utils/agent/CommercialOwnerShield';

export function getCommercialOwnerTagTitle(type: CommercialOwnerShield['tagType']): string {
  switch (type) {
    case EAccountType.ManagementCompany:
      return 'Управляющая компания';

    case EAccountType.RentDepartment:
      return 'Отдел аренды';

    case 'yeoman':
    default:
      return 'Собственник';
  }
}
